import { createSlice } from '@reduxjs/toolkit';
import { ISkill } from '../../../../dto';
import { setSkill } from '../actions';
import { MN_SKILLS, TYPE_ELEMENT } from '../../../../common';

export interface SkillState {
  data: ISkill | null;
  loading: boolean;
  error: string | null;
}

const initialState: SkillState = {
  data: null,
  loading: false,
  error: null,
};

export const skillSlice = createSlice({
  name: `${MN_SKILLS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSkill, (state, { payload }) => {
      state.data = payload;
    });
  },
});
